// s910-key_details
import selfHtml from './s910-key_details.html' with { type: 'text' };;

import { mod_loader , InviteModule} from "../AppState.js"

import { showOffcanvas } from "../utils.js";

var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root

    if (args.key == null) 
        return showOffcanvas('offcanvasAddkeyPanel', () => mod_loader(InviteModule));

    root.querySelector(".myKeyPairUserID").value = args.key.myKeyPairUserID;
    root.querySelector(".myKeyPairFingerprint").value = formatSerial(args.key.myKeyPairFingerprint);
    root.querySelector(".myKeyPairKeyID").value = formatSerial(args.key.myKeyPairKeyID);
    root.querySelector(".myKeyPairPublicKey").value = args.key.myKeyPairPublicKey;

    if (!args.key.isSelfKey)
        root.querySelector(".self_key").classList.add("d-none");
    else 
        root.querySelector(".self_key").classList.remove("d-none");
}


function formatSerial(str) {
    return str
        .toUpperCase()           // convert to upper case
        .match(/.{1,4}/g)        // split into groups of 4
        .join(' ');              // join with spaces
}
